const MoreVertical = () => (
  <>
    <path
      fill="currentColor"
      d="M12 19.23q-.507 0-.868-.36a1.19 1.19 0 0 1-.362-.87q0-.507.362-.87.36-.36.869-.36.507 0 .869.36.362.363.362.87t-.362.87q-.36.36-.87.36m0-6q-.507 0-.868-.36a1.19 1.19 0 0 1-.362-.87q0-.507.362-.87.36-.36.869-.36.507 0 .869.36.362.362.362.87 0 .507-.362.87-.36.36-.87.36m0-6q-.507 0-.868-.36A1.19 1.19 0 0 1 10.77 6q0-.507.362-.87.36-.36.869-.36.507 0 .869.36.362.363.362.87 0 .508-.362.87-.36.36-.87.36"
    />
  </>
)
export default MoreVertical
